import * as React from 'react';

import { useIntl } from 'react-intl';
import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import MembershipDashboard from 'src/features/membership/components/MembershipDashboard';
import MembershipsTable from 'src/features/membership/components/table/MembershipsTable';
import { ALL_CATEGORIES } from 'src/features/membership/utils/constants';
import { membershipMessages } from 'src/features/membership/utils/messages';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { useTitleStore } from 'src/stores/useTitleStore';

const MembershipsRoutes = () => {
    const { formatMessage } = useIntl();

    const accessMemberships = useHasPermissions([PERMISSION.ACCESS_MEMBERSHIPS]);

    const { setTitle, removeTitle } = useTitleStore();
    React.useEffect(() => {
        setTitle(formatMessage(membershipMessages.memberships));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <Routes>
            <Route index element={<Navigate to={ALL_CATEGORIES} replace />} />
            <Route path=":category">
                {accessMemberships && <Route path="" element={<MembershipsTable />} />}
                {accessMemberships && (
                    <Route path=":membershipId/:membershipTypeId" element={<MembershipDashboard />} />
                )}
            </Route>
            {accessMemberships && <Route path=":category/:membershipId" element={<MembershipDashboard />} />}
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    );
};

export default MembershipsRoutes;
